<template>
    <div>
        <b-card :header="uLang('app.enrol_candidate_to_trajectory')" header-tag="h4" class="bg-default-card">
            <trajectory-enrolment-form v-if="relation" :relation="relation" :override-endpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import TrajectoryEnrolmentForm from '~/components/forms/admin/relation/trajectory-enrolment/form'

    export default {
        name: 'create',

        props: {
            relationId: {
                required: true,
            },
        },

        data() {
            return {
                relation: undefined,
            };
        },

        components: {
            'trajectory-enrolment-form': TrajectoryEnrolmentForm,
        },

        created() {
            this.retrieveRelation();
        },

        methods: {
            async retrieveRelation() {
                const { data } = await window.axios.get('/api/admin/relations/' + this.relationId);
                this.relation = data;
            },
        },

        computed: {
            overrideEndpoint() {
                return route('relations.trajectory-enrolments.store', {relation: this.relationId});
            }
        }
    }
</script>

<style lang="css" scoped>
</style>
